<template>
  <div v-show="isModalVisible">
    <div id="groupModal6" class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop v-if="loading == false">
        <div class="modal-header">
          <div class="col-11 p-0 float-left text-center">
          <img class="w-60 mt1" src="@/assets/MM-logo.png" alt="MentorMentee" width="100px">
          </div>
        </div>
        <div class="modal-body">
          <div style="margin-bottom: 10px;"></div>
          <div class="col-12 p-0">
            <div class="col-12 item-text bold p-0" style="margin-bottom: 10px;">
              Skill pass allows you to force pass a mentees earned competencies that were not recorded in the rep submission/review process.
            </div>
            <div class="col-12 item-text text-align-center" style="margin-bottom: 10px;">
              This is most commonly used when...
            </div>
            <div class="col-12 item-text" style="padding-left: 30px; margin-bottom: 17px;">
              1 - A new or current technician is added as a mentee.<br />
              2 - Competency was earned but not recorded in Mentor Mentee
            </div>
            <div class="col-12 item-text text-align-center bold" style="margin-bottom: 10px;">
              <i class="fa fa-exclamation-triangle angle-class" aria-hidden="true" ></i> Warning! Once passed competency can not be undone. <i class="fa fa-exclamation-triangle angle-class" aria-hidden="true" ></i>
            </div>
          </div>
        </div>
        <div class="modal-footer" >
          <div class="col-12 p-0" >
            <div class="col-6 float-left p-0 text-left">
              <button type="submit" class="btn btn-primary btn-md start-button" @click="closeModal()">Cancel</button> 
            </div>
            <div class="col-6 float-left p-0 text-align-right">
              <button type="submit" class="btn btn-primary btn-md start-button-blue" @click="openSkillPass()">Continue</button> 
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import router from '../../router/index.js';

export default {
    props: ['isModalVisible', 'menteeId', 'tasklistId'],
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        closeModal() {
          this.$emit('close');
        },
        openSkillPass() {
          this.$emit('openSkillPass');
        },
        scrollTop() {
          

        },
    },
    created() {
      
    },
}
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: hidden;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 300px;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 580px;
  height: 350px;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 30px;
  overflow-y: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;  
}
.modal-body {
  margin: 0px;
  padding: 0;
  overflow-y: auto;
  
  font-size: 16px;
}
.modal-body-h1 {
  height: 240px;
}
.modal-body-h2 {
  height: 315px;
}
.modal-footer {
  padding: 0px;
  margin: 30px 0;
  text-align: center;
  border: 0;
}
.modal-header {
  padding: 0px;
  border-bottom: 0 none;
  margin-bottom: 10px;
  margin-top: 0px;
  color: #717171;
  font-size: 15px;
}
.modal-header .close {
  padding: 5px;
  font-size: 33px;
}
.slide-title {
  font-size: 18px;
  color: #00ACEE;
  font-weight: bold;
  margin-top: 5px;
}
.item-text, .question_text {
  color: #002F42;
  font-size: 15px;
}
.assessment_title {
  color: #717171;
  font-size: 19px;
}
.link_text {
  color: #717171;
  font-weight: bold;
  font-size: 17px;
  text-decoration: underline;
}
.start-button {
  color: #29A3E4 !important;
  background-color: #FFF !important;
  border: 1px solid #29A3E4 !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 10px 10px 10px 10px;
  line-height: 8px;
  width: 87px;
}
.start-button-blue {
  color: #fff;
  background-color: #29A3E4 !important;
  border: 1px solid #29A3E4 !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 10px 10px 10px 10px;
  line-height: 8px;
  width: 87px; 
}
.angle-class {
  color: #EC511F;
  font-size: 22px;
  padding-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/skillPassWarningModal.vue